export default "__VITE_ASSET__09fee1bc__"